import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function Close(props) {
  const socket = useContext(SocketContext);
  const symbol_id = props.symbol_id;

  const [close, setClose] = useState(0);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data != null && data.Previous_Close !== undefined) {
        setClose(data.Previous_Close);
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  return (
    <div className="menuClose">
      <CheckValue number={close} extra={"small"} />
    </div>
  );
}
